var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKmon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F231AF",
    d: "m9.772 13.08l.844 2.387a.62.62 0 0 0 .771.36a.564.564 0 0 0 .382-.72l-.669-1.864l3.737 1.701c.322.146.708.026.862-.274a.586.586 0 0 0-.292-.806l-3.835-1.748l1.907-3.086c.171-.291.056-.66-.274-.814c-.33-.155-.75-.052-.926.24l-1.826 2.957l-.566-1.594a.617.617 0 0 0-.767-.36a.565.565 0 0 0-.385.72l.411 1.157v.021c-.017.557-.206 1.072-.763 1.072c-.998 0-.998-1.698-.998-2.186c0-.484.364-3.784 4.572-3.784c4.213 0 5.61 3.6 5.61 5.631s-1.564 5.481-5.888 5.481c-.112 0-.917 1.286.206 1.286c3.78 0 6.972-3.077 6.972-6.878c0-.9-.265-3.365-2.485-5.208a6.48 6.48 0 0 0-4.359-1.628c-1.68 0-3.051.621-3.951 1.316c-1.886 1.457-1.997 3.668-1.997 4.084c0 .99.57 3.171 2.28 3.171a1.72 1.72 0 0 0 1.427-.634"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKmon0)",
    d: "M11.799 17.571v1.286h-.009c-6.54 0-7.933-7.406-7.933-7.406l1.115-.308c0 1.646 2.34 6.428 6.613 6.428z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKmon0",
    x1: 12.682,
    x2: 3.42,
    y1: 18,
    y2: 17.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F231AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmon);
export default __webpack_public_path__ + "static/media/kmon.6e160bc2c3845d9e646d366cc959ef3d.svg";
export { ForwardRef as ReactComponent };